import React, { useEffect } from "react";
import logoHeaderWhite from "../Resources/img/logoHeader.png";
import logoHeaderRed from "../Resources/img/logoHeader2.png";
import logoHeaderMobile from "../Resources/img/logoMobile.png";
import IconLogoutRespons from "./iconLogoutRespons";
import IconLogout from "./iconLogout";
import { Link, NavLink, useLocation, withRouter } from "react-router-dom";
import iconHealth from "../Resources/img/icon-health.png";
import iconDropdown from "../Resources/img/icon-dropdown-arrow.png";
import { useDispatch, useSelector } from "react-redux";
import ModalSISCO from '../Components/modalSISCO';
import {
  updateShowSisco
} from "../Store/secureInvestmentIncome/actions";
import {
  onlyLinkProductsAccess,
  onlyLinkSimulatesAccess,
  onlyLinkQuotesAccess,
  onlyLinkAprovationsAccess,
  showModulesAccess
} from "../Utils/onlyProductAccess";
import { USERS_ROLE } from "../../src/Utils/constants.js";

const Header = ({ openPanel, closePanel, active }) => {
  const dispatch = useDispatch();
  const isLogin = useSelector((state) => state.login.granted);
  const channel = useSelector((state) => state.login.channel);
  const modulesAccess = useSelector((state) => (state.login.access_configuration && state.login.access_configuration.modules) || []);
  const idUser = useSelector((state) => state.login.idClient);
  const showSISCO = useSelector((state) => state.cotizador.showSISCO_STATE);
  // const access_configuration = useSelector(
  //   (state) => (state.login && state.login.access_configuration) || null
  // );
  const setValuesDynatrace = () => {
    if (window.dtrum) {
      window.dtrum.endSession();
    }

    if (isLogin) {
      window.idClient = idUser;
    }
  };

  const openSiscoModal = () => {
    dispatch(updateShowSisco(true))
  }

  useEffect(() => {
    setValuesDynatrace();
  }, [idUser]);

  const location = useLocation();

  const pathLink = location.pathname.replaceAll("/", " ");
  const pathLinkTransform = pathLink[1].toUpperCase() + pathLink.substring(2);
  useEffect(() => {
    window.digitalData.push({
      action: {
        group: "Navegación",
        category: "Menu Principal",
        name: "Navegar",
        label: pathLinkTransform,
      },
      event: "trackAction",
    });
  }, [location]);
  // const USERS_ROLE = {
  //   admin: "Administrador",
  //   renta: "Renta",
  //   vida: "Vida",
  //   vidapiloto: "Vida Piloto",
  //   tlmkt: "Telemarketing",
  //   suscript: "suscriptor",
  //   broker: "Broker"
  // };

  const ROL_USER_DEFAULT = "";

  const rolLogged = USERS_ROLE[channel] || ROL_USER_DEFAULT;

  return (
    <header className={`header ${channel === null && "is-off"}`}>
      <div className="wrap">
        {
          isLogin && (<div className="header__container">
            {modulesAccess.length > 0 && (
              <div className="header__container__logo">
                {channel === null ? (
                  <img src={logoHeaderWhite} alt="logoHeader" />
                ) : (
                  <img src={logoHeaderRed} alt="logoHeader" />
                )}
                <img
                  className="logo-mobile"
                  src={logoHeaderMobile}
                  alt="logoHeader"
                />
                {channel !== null && <span>{rolLogged}</span>}
              </div>
            )}
            <div className="header__container__navbar">
              {modulesAccess.length > 0 && (
                <>
                  <div className="header__container__navbar__wrapper">
                    <ul className="header__container__navbar__nav menu">
                      {showModulesAccess(modulesAccess, 'productos') && (
                        <li className="submenu nav-item">
                          <NavLink
                            to="/productos"
                            className="nav-link"
                            activeClassName="active-link"
                          >
                            <span className="nav-link--label">Productos</span>
                          </NavLink>
                        </li>
                      )}

                      {showModulesAccess(modulesAccess, 'simulaciones') && (
                        <li className="submenu nav-item">
                          <NavLink
                            to="/simulaciones"
                            className="nav-link"
                            activeClassName="active-link"
                          >
                            <span className="nav-link--label">Simulaciones</span>
                          </NavLink>
                        </li>
                      )}

                      {showModulesAccess(modulesAccess, 'cotizaciones') && (
                        <li className="submenu nav-item">
                          <NavLink
                            to="/cotizaciones"
                            className="nav-link"
                            activeClassName="active-link"
                          >
                            <span className="nav-link--label">Cotizaciones</span>
                          </NavLink>
                        </li>
                      )}

                      {showModulesAccess(modulesAccess, 'aprobaciones') && (
                        <li className="submenu nav-item">
                          <NavLink
                            to="/aprobaciones"
                            className="nav-link"
                            activeClassName="active-link"
                          >
                            <span className="nav-link--label">Aprobaciones</span>
                          </NavLink>
                        </li>
                      )}
                      {showModulesAccess(modulesAccess, 'configuraciones') && (
                        <li className="submenu nav-item">
                          <a className="nav-link">
                            <span className="nav-link--label">
                              Configuración{" "}
                              <img src={iconDropdown} alt="icon-dropdown" />
                            </span>
                          </a>
                          <ul className="dropdown-menu">
                            <li className="nav-item">
                              <Link to="/configuracion/AS" className="nav-link">
                                <img src={iconHealth} alt="icon-health" />
                                <span>Ahorro Seguro</span>
                              </Link>
                            </li>
                            <li className="nav-item">
                              <div onClick={() => openSiscoModal()}>
                                <img src={iconHealth} alt="icon-health" />
                                <span>Renta Vitalicia</span>
                              </div>
                              {/* </Link> */}
                            </li>
                            <li className="nav-item">
                              <Link to="/configuracion/RI" className="nav-link">
                                <img src={iconHealth} alt="icon-health" />
                                <span>Renta Inversión</span>
                              </Link>
                            </li>
                            <li className="nav-item">
                              <Link
                                to="/configuracion/boletines"
                                className="nav-link"
                              >
                                <img src={iconHealth} alt="icon-health" />
                                <span>Boletines de Inversión</span>
                              </Link>
                            </li>
                            <li className="nav-item">
                              <Link
                                to="/configuracion/factsheets"
                                className="nav-link"
                              >
                                <img src={iconHealth} alt="icon-health" />
                                <span>Factsheets Inversiones</span>
                              </Link>
                            </li>
                          </ul>
                        </li>
                      )}
                    </ul>
                  </div>

                  <ul className="header__container__navbar__nav menu">
                    <li className="submenu nav-item">
                      <IconLogout />
                    </li>
                    <IconLogoutRespons
                      openPanel={openPanel}
                      closePanel={closePanel}
                      active={active}
                    />
                  </ul>
                </>
              )}
            </div>
          </div>
          )
        }
      </div>
      {showSISCO && <ModalSISCO open={showSISCO} />}
    </header>
  );
};

export default withRouter(Header);
